// Auth header for RAG calls made with `fetch` instead of axios.
//
// utils/ragAxiosAuth.js installs an *axios* request interceptor, so every
// existing RAG call site gets its `Authorization: Bearer <supabase jwt>` for
// free. A `fetch` call gets nothing — the streaming speaker-label consumer in
// MedicalScribeTranscriptionData.js proves the trap: it POSTs with only a
// Content-Type and sends no token at all. The Ask Sophie streaming route is
// behind the RAG JWT boundary (tikcare_rag src/credit_wallet_rag_boundary.py),
// so it would answer 401 for every doctor. This helper exists so the header
// cannot be forgotten a third time.
import { supabase } from '../supabaseClient.js';

// Unlike the axios interceptor — which swallows a token lookup failure because
// it is a global hook spanning ~18 unrelated call sites — this throws. There is
// exactly one caller, an unauthenticated POST to it can only ever 401, and
// failing before the network gives the call site a real error to show.
export async function ragStreamHeaders() {
  const { data: { session } = {} } = await supabase.auth.getSession();
  const token = session?.access_token;
  if (!token) {
    throw new Error('No Supabase session: refusing to send an unauthenticated RAG stream request');
  }
  return {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${token}`,
  };
}
